import {DatePipe} from '@angular/common';
import {Component, inject, input, signal} from '@angular/core';
import {
	IonButton,
	IonCard,
	IonCardContent,
	IonCardHeader,
	IonCardSubtitle,
	IonCardTitle,
	IonIcon,
	IonItem,
	IonLabel,
	PopoverController
} from '@ionic/angular/standalone';
import {TranslocoDirective} from '@jsverse/transloco';
import {AppAvatarComponent} from '@components';
import {Invitation, Profile} from '@models';
import {InvitationService, PresenceService} from '@services';
import {MessagePopinComponent} from '../message-popin/message-popin.component';
import {ProfilePopinComponent} from '../profile-popin/profile-popin.component';

@Component({
	           selector: 'app-invit',
	           standalone: true,
	           templateUrl: './invit.component.html',
	           styleUrls: ['./invit.component.scss'],
	           imports: [
			TranslocoDirective,
		           IonItem,
		           IonCard,
		           IonCardHeader,
		           IonCardTitle,
		           AppAvatarComponent,
		           IonLabel,
		           IonCardSubtitle,
		           DatePipe,
		           IonCardContent,
		           IonButton,
		           IonIcon
	           ]
           })
export class InvitComponent {
	currentProfile = input.required<Profile>();
	invitation = input.required<Invitation>();
	invitProfile = input.required<Profile>();
	received = input.required<boolean>();

	private invitationService = inject(InvitationService);
	private presenceService = inject(PresenceService);
	private popover = inject(PopoverController);

	constructor() {
	}

	accept() {
		if (!this.invitation()) {
			return;
		}
		this.invitationService.accepte(this.invitation());
	}

	decline() {
		if (!this.invitation()) {
			return;
		}
		this.invitationService.denied(this.invitation());
	}

	createPopover() {
		if (!this.invitation()) {
			return;
		}
		const snapshot = this.presenceService.getPresence(this.invitation().sender)();
		if (!snapshot) {
			return;
		}
		this.popover.create({
			                    component: ProfilePopinComponent,
			                    backdropDismiss: true,
			                    cssClass: 'profile-popover',
			                    componentProps: {
				                    profile: signal(this.invitProfile()),
				                    currentProfile: signal(this.currentProfile()),
				                    selected_status: signal(snapshot.status),
				                    isPrivate: true
			                    },
			                    showBackdrop: false
		                    }).then((popoverElement: { present: () => Promise<void> }) => {
			return popoverElement.present();
		});
	}

	openProfilePopover(event: Event) {
		event.preventDefault();
		event.stopPropagation();
		this.createPopover();
	}

	createMessagePopover(message: string, event: Event) {
		this.popover.create({
			                    component: MessagePopinComponent,
			                    event,
			                    backdropDismiss: true,
			                    cssClass: 'profile-popover',
			                    componentProps: {
				                    message: message
			                    },
			                    showBackdrop: true
		                    }).then((popoverElement: { present: () => Promise<void> }) => {
			return popoverElement.present();
		});
	}

	protected getInitials(username: string): string {
		if (!username || !username.trim()) {
			return '?';
		}
		const parts = username.trim().split(/\s+/);
		if (parts.length >= 2) {
			return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
		}
		return username.slice(0, 2).toUpperCase();
	}
}
